import { render, staticRenderFns } from "./acl-refresh-dialog.vue?vue&type=template&id=0f6a9660&scoped=true"
import script from "./acl-refresh-dialog.vue?vue&type=script&lang=js"
export * from "./acl-refresh-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a9660",
  null
  
)

export default component.exports